import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./style.css";

const Support = () => {
  const supportItems = [
    {
      name: "Product",
      img: "./images/apply/sup-prod.png",
      list: [
        "Product Consulting",
        "Documents Consulting",
        "Tokenomics Consulting",
        "Security & Audit Consulting",
        "Legal Service Connection",
      ],
    },
    {
      name: "Listing",
      img: "./images/apply/sup-listing.png",
      list: [
        "CEX & DEX Listing Support",
        "CGK and CMC Listing Support",
        "Tokenomics Consulting",
        "Market Maker Support/ Connection",
      ],
    },
    {
      name: "Fund raising",
      img: "./images/apply/sup-fund.png",
      list: [
        "VCs Connection",
        "Launchpads & Partners Connection",
        "Investments",
      ],
    },
    {
      name: "Marketing & PR",
      img: "./images/apply/sup-pr.png",
      list: ["Marketing Package", "PR on media / e-newspapers"],
    },
    {
      name: "Xconnect",
      img: "./images/apply/planet.png",
      list: ["Community Growth Campaigns", "User Data & Analytics Dashboard", "Boost Engagement & Brand Awareness"],
    },
  ];

  return (
    <div className="container sup">
      <div className="title-sup">
        <div className="title-sup-top">Comprehensive support</div>
      </div>

      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        spaceBetween={30}
        slidesPerView={3}
        navigation
        pagination={{ clickable: true }}
        autoplay={{ delay: 3000, disableOnInteraction: false }}
        loop={true}
        breakpoints={{
          0: { slidesPerView: 1 },
          768: { slidesPerView: 2 },
          1024: { slidesPerView: 3 },
        }}
        className="sup-carousel"
      >
        {supportItems.map((item, idx) => (
          <SwiperSlide key={idx}>
            <div className="wrap-box">
              <div className="gradient-shadow"></div>
              <div className={`box-sub-item`}>
                <div className="icon-sup">
                  <img src={item.img} alt={item.name} />
                </div>
                <div className="sup-name">{item.name}</div>
                <div className="sup-list-des">
                  <ul>
                    {item.list.map((li, i) => (
                      <li key={i}>{li}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Support;
